<p-toast position="bottom-right"></p-toast>
<p-confirmDialog></p-confirmDialog>
<app-archive-sidebar>
  <app-archive-tasks-button bottom [origins]="[origin]"
                            [buttonTitle]="'page.profile.report.tasks'"></app-archive-tasks-button>
  <app-crud-table body #crudTable [crudService]="crudService"
                  [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'name'" [fieldEnabled]="'active'"
                  [tableConfig]="tableConfig" [newRecord]="newRecord" [tableLoading]="tableLoading"
                  [(formRecord)]="formRecord" [formConfig]="formConfig"
                  [(dialogFormVisible)]="dialogFormVisible" (dialogFormVisibleChange)="onFormShow()"
                  [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                  [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                  [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                  [prepareForEdit]="prepareRecordForEdit" [prepareForClone]="prepareRecordForClone"
                  [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                  [lazyLoadOnInit]="true" [totalRecords]="totalRecords" (onContextMenuShow)="refreshContextMenu()"
                  (onClearTableFilter)="clearProfileType()" [dialogClass]="'cc-profile-form-dialog'"
                  (tableCurrentRequestChange)="tableCurrentRequestChanged()"
                  (onTableResultGet)="loadTypes($event)"
  >
        <span table-toolbar-left>
              <i class="toolbar-separator fa fa-diamond"></i>
        </span>
    <span table-toolbar-left class="filter-label ml-10-imp" *ngIf="profileTypes.length>0">
          {{'page.profile.report.filter.types' |translate}}
        </span>
    <span table-toolbar-left *ngIf="profileTypes.length>0">
          <p-multiSelect [options]="profileTypes" [(ngModel)]="selectedTypes"
                         optionLabel="text" class="profile-type-menu"
                         (onChange)="profileTypeChanged()"></p-multiSelect>
        </span>
  </app-crud-table>
</app-archive-sidebar>

<app-batch-update-profile-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                               [selectedRecords]="selectedRecords"
                               [formRecord]="batchFormRecord"
                               [transPartKey]="'profile.report'"
                               (onSavedForm)="onSaved()"
                               [origin]="ORIGIN.WEB_REPORT"
                               [executionDaysOfMonthValues]="executionDaysOfMonthValues"
                               [executionTimesValues]="executionTimesValues"
                               [exportDateModes]="exportDateModes"
                               [exportFormats]="exportFormats"
                               [profileTypes]="profileTypes"
                               [transferFileLocationsValues]="transferFileLocationsValues"
                               [transferMailTemplates]="transferMailTemplates"
                               [visibilities]="visibilities"
                               [userGroups]="userGroups"
></app-batch-update-profile-form>
